import { AutocompleteProps, NumberInputProps, SelectProps, TextareaProps, TextInputProps } from "@mantine/core";
import { DateInputProps } from "@mantine/dates";
import { ValidationError } from "@/components/ValidationError";

export const getInputProps = (
  props: TextInputProps | TextareaProps | SelectProps | DateInputProps | AutocompleteProps | NumberInputProps,
  focused: boolean
) => {
  const searchValue = (props as SelectProps).searchValue;
  const hasValue =
    (props.value !== "" && props.value !== undefined && props.value !== null) ||
    (searchValue !== "" && searchValue !== undefined);
  return {
    labelProps: {
      "data-floating": hasValue || focused || !!props.placeholder,
      "data-disabled": props.disabled,
      "data-with-left-section": props.leftSection !== undefined,
    },
    "data-filled": hasValue && !focused,
    error: props.error ? <ValidationError>{props.error}</ValidationError> : undefined,
  };
};
